/* eslint-disable @typescript-eslint/no-explicit-any */
import { computed, ref } from 'vue';
import {
  IOrgLoadResDto,
  OrgsApiService,
} from '~packages/epk-front-shared/api-client';

import { useLoading } from '@/shared/lib';
import { useNotificationStore, useOrgStore } from '@/shared/model';

import { employeeListAccessFilter } from './employee-list-access-filter';
import { employeeListFactory } from './employee-list.factory';
import { IEmployeeDto } from './types';

export const useOrg = (setIsLoading?: any) => {
  const { setIsLoading: setIsLoadingBase } = useLoading();
  const { notifyError } = useNotificationStore();

  const orgStore = useOrgStore();

  const apiService = new OrgsApiService();
  const setIsLoadingToUse = setIsLoading ?? setIsLoadingBase;

  const employeeList = ref([] as IEmployeeDto[]);
  const isInited = ref(false);
  const isLoading = ref(false);
  const oktmoDtoList = ref([] as IOrgLoadResDto['gen_oktmos']);
  const orgHead = ref('' as string | null);
  const title = ref('');

  const hasRoleHead = computed(() =>
    orgStore.userInfo.approved_roles.includes('is_head')
  );
  const orgUserIsHead = computed(() => orgStore.userInfo.user.user_is_head);
  // TODO при каждом вызове useOrg обнуляется внутреннее состояние =Ю нет данных в orgHead и т.д.
  // + будут по несколько раз пересчитываться computed. МБ провайлить или перейти еа стор
  const isLeader = computed(() => orgUserIsHead.value || hasRoleHead.value);
  const leader = computed(() => {
    const user = orgStore.userInfo;
    return isLeader.value
      ? user.user_fio
      : orgHead.value || user?.head?.toReversed()?.join(' ');
  });

  const errFactory = (r: any, msg: string) => {
    setIsLoadingToUse(false);
    notifyError(msg);
    isLoading.value = false;
    isInited.value = true;
    return r;
  };

  const init = async () => {
    if (isInited.value || isLoading.value) return { status: undefined };
    isLoading.value = true;

    if (!orgStore.isInited) {
      await orgStore.init();
    }

    setIsLoadingToUse(true);
    const idToUse = orgStore.userInfo.org_choose?.code;
    if (!idToUse) {
      return errFactory({ status: false }, 'У вас не привязана организация');
    }

    const r = await apiService.fetch(idToUse, { use_pagination: false });

    if (!r.status) {
      return errFactory(r, 'Не удалось получить информацию об организации');
    }

    /*  */
    const response = r.response as IOrgLoadResDto;
    const oktmoDtoListNew = response.gen_oktmos;

    const orgOktmoLanded = orgStore.userInfo.org_choose?.landed_oktmo_code;
    const newEmployeeList = employeeListFactory(response.users);
    employeeList.value = employeeListAccessFilter(
      newEmployeeList,
      orgOktmoLanded
    );

    const responseOrgHead = response.org_head;

    orgHead.value = responseOrgHead
      ? `${responseOrgHead.user_last_name} ${responseOrgHead.user_first_name}`
      : '';
    oktmoDtoList.value = oktmoDtoListNew;
    title.value = response.org.org_name;

    isLoading.value = false;
    isInited.value = true;

    setIsLoadingToUse(false);
    return r;
  };

  return {
    isLeader,
    init,
    employeeList,
    leader,
    oktmoDtoList,
    title,
    orgStore,
    isInited,
  };
};
